import script from "./DemoModeBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoModeBanner.vue?vue&type=script&setup=true&lang=js"

import "./DemoModeBanner.vue?vue&type=style&index=0&id=fdfb368c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdfb368c"]])

export default __exports__